// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/NotificationsPage/NotificationsPage.scss */
.notif-page {
  background: #f7f9fa;
  min-height: 100vh;
}

.notif-container {
  max-width: 420px;
  margin: 0 auto;
  padding: 0 14px 36px 14px;
}

.notif-title-h1 {
  font-size: 1.32rem;
  font-weight: 700;
  margin: 0 0 13px 0;
  color: #232137;
  letter-spacing: 0.01em;
  line-height: 1.15;
}

.notif-empty {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);
  padding: 18px 12px 18px 12px;
  margin-bottom: 22px;
  color: #67687a;
  font-weight: 500;
  text-align: center;
}
.notif-empty.error {
  color: #e72f44;
}

.notif-filters {
  display: inline-flex;
  padding: 4px;
  border-radius: 999px;
  background-color: rgba(0, 0, 0, 0.03);
  margin-bottom: 16px;
}

.notif-filter-btn {
  border: none;
  outline: none;
  cursor: pointer;
  font: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  background: transparent;
  min-width: 120px;
}
.notif-filter-btn.active {
  background: #ffffff;
  color: #0D263F;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.notif-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notif-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);
  padding: 12px 14px 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.notif-card.unread {
  border-color: rgba(231, 47, 68, 0.2);
  background: #fff7f8;
}

.notif-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.notif-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.notif-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e72f44;
  flex-shrink: 0;
}

.notif-title {
  margin: 0;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.3;
  color: #0D263F;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notif-date {
  flex-shrink: 0;
  font-size: 12px;
  color: #999;
  margin-left: 8px;
  white-space: nowrap;
}

.notif-tag {
  align-self: flex-start;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f1f1f1;
  color: #555;
}
.notif-tag--promo {
  background-color: rgba(228, 1, 54, 0.1);
  color: #E40136;
}
.notif-tag--system {
  background-color: rgba(13, 38, 63, 0.08);
  color: #0D263F;
}
.notif-tag--booking {
  background-color: rgba(0, 153, 102, 0.12);
  color: #009966;
}

.notif-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #4A4A4A;
  white-space: pre-line;
}

.notif-loadmore-wrap {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.notif-loadmore {
  width: 100%;
  border: none;
  background: #232137;
  color: #fff;
  font-size: 1.02rem;
  font-weight: 700;
  border-radius: 36px;
  padding: 12px 0 9px 0;
  cursor: pointer;
  display: block;
  box-shadow: 0 2px 10px 0 rgba(36, 41, 57, 0.08);
  transition: background 0.14s;
}
.notif-loadmore:active {
  background: #1a1a29;
}

@media (max-width: 500px) {
  .notif-container {
    padding: 0 4vw 30px 4vw;
  }
  .notif-title-h1 {
    font-size: 1.09rem;
  }
  .notif-filter-btn {
    min-width: 110px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/NotificationsPage/NotificationsPage.scss"],"names":[],"mappings":"AAAA,uDAAA;AACA;EACE,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,qCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6EAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,mBAAA;EACA,mBAAA;EACA,+CAAA;EACA,4BAAA;EACA,qCAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;AAKE;EACE,oCAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAJF;;AAOA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;AAJF;AAME;EACE,uCAAA;EACA,cAAA;AAJJ;AAME;EACE,wCAAA;EACA,cAAA;AAJJ;AAME;EACE,yCAAA;EACA,cAAA;AAJJ;;AAQA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AALF;;AAQA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,+CAAA;EACA,4BAAA;AALF;AAOE;EACE,mBAAA;AALJ;;AASA;EACE;IAAmB,uBAAA;EALnB;EAMA;IAAkB,kBAAA;EAHlB;EAIA;IAAoB,gBAAA;IAAkB,eAAA;EAAtC;AACF","sourcesContent":["/* src/pages/NotificationsPage/NotificationsPage.scss */\r\n.notif-page {\r\n  background: #f7f9fa;\r\n  min-height: 100vh;\r\n}\r\n\r\n.notif-container {\r\n  max-width: 420px;\r\n  margin: 0 auto;\r\n  padding: 0 14px 36px 14px;\r\n}\r\n\r\n.notif-title-h1 {\r\n  font-size: 1.32rem;\r\n  font-weight: 700;\r\n  margin: 0 0 13px 0;\r\n  color: #232137;\r\n  letter-spacing: 0.01em;\r\n  line-height: 1.15;\r\n}\r\n\r\n.notif-empty {\r\n  background: #fff;\r\n  border-radius: 20px;\r\n  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);\r\n  padding: 18px 12px 18px 12px;\r\n  margin-bottom: 22px;\r\n  color: #67687a;\r\n  font-weight: 500;\r\n  text-align: center;\r\n\r\n  &.error {\r\n    color: #e72f44;\r\n  }\r\n}\r\n\r\n.notif-filters {\r\n  display: inline-flex;\r\n  padding: 4px;\r\n  border-radius: 999px;\r\n  background-color: rgba(0, 0, 0, 0.03);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.notif-filter-btn {\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\r\n\r\n  padding: 8px 14px;\r\n  border-radius: 999px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #555;\r\n  background: transparent;\r\n  min-width: 120px;\r\n\r\n  &.active {\r\n    background: #ffffff;\r\n    color: #0D263F;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  }\r\n}\r\n\r\n.notif-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.notif-card {\r\n  background: #ffffff;\r\n  border-radius: 20px;\r\n  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);\r\n  padding: 12px 14px 12px 14px;\r\n  border: 1px solid rgba(0, 0, 0, 0.03);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n\r\n  &.unread {\r\n    border-color: rgba(231, 47, 68, 0.2);\r\n    background: #fff7f8;\r\n  }\r\n}\r\n\r\n.notif-top {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.notif-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.notif-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #e72f44;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notif-title {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  line-height: 1.3;\r\n  color: #0D263F;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.notif-date {\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  color: #999;\r\n  margin-left: 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.notif-tag {\r\n  align-self: flex-start;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background-color: #f1f1f1;\r\n  color: #555;\r\n\r\n  &--promo {\r\n    background-color: rgba(228, 1, 54, 0.1);\r\n    color: #E40136;\r\n  }\r\n  &--system {\r\n    background-color: rgba(13, 38, 63, 0.08);\r\n    color: #0D263F;\r\n  }\r\n  &--booking {\r\n    background-color: rgba(0, 153, 102, 0.12);\r\n    color: #009966;\r\n  }\r\n}\r\n\r\n.notif-text {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  color: #4A4A4A;\r\n  white-space: pre-line;\r\n}\r\n\r\n.notif-loadmore-wrap {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.notif-loadmore {\r\n  width: 100%;\r\n  border: none;\r\n  background: #232137;\r\n  color: #fff;\r\n  font-size: 1.02rem;\r\n  font-weight: 700;\r\n  border-radius: 36px;\r\n  padding: 12px 0 9px 0;\r\n  cursor: pointer;\r\n  display: block;\r\n  box-shadow: 0 2px 10px 0 rgba(36, 41, 57, 0.08);\r\n  transition: background 0.14s;\r\n\r\n  &:active {\r\n    background: #1a1a29;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .notif-container { padding: 0 4vw 30px 4vw; }\r\n  .notif-title-h1 { font-size: 1.09rem; }\r\n  .notif-filter-btn { min-width: 110px; font-size: 13px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
